import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class EstimatedHalfLifeMapping implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'EstimatedHalfLifeMapping';
  readonly apiRoute: string = CONFIG.apiRoutes.runnableModelMetadataGetEstimatedHalfLifeOutputMapping;

  modelId: string;
  nodeOutputId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.modelId = data.modelId;
    this.nodeOutputId = data.nodeOutputId;
  }
}
